import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import device from "current-device";
import GroupsIcon from '@mui/icons-material/Groups';
import { useTranslation } from "react-i18next";



export function FormCreateTeamDialog(props) {
  const { openDialog, setOpenDialog, sendFormCreateTeam } = props;
  const { t } = useTranslation("global")

  const input_name_ref = useRef("");
  const input_label_ref = useRef("");
  const input_email_ref = useRef("");
  const input_school_ref = useRef("");
  const input_zip_code_ref = useRef("");
  const input_information_ref = useRef("");
  const [formCompleted, setFormCompleted] = useState(false)

  useEffect(() => {
  }, [openDialog]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const sendForm = () => {
    const formCreateTeam = {
      name: input_name_ref.current.value,
      label: input_label_ref.current.value,
      email: input_email_ref.current.value,
      school: input_school_ref.current.value,
      zip_code: input_zip_code_ref.current.value,
      information: input_information_ref.current.value,
    };
    sendFormCreateTeam(formCreateTeam);
    // handleClose();
  };

  const handleChange = (e) => {

    if (e.target === input_name_ref.current) {
      let inputValue = e.target.value;
      //inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
      inputValue = inputValue.replace(/[^a-zA-Z0-9_-]/g, '');
      inputValue = inputValue.toUpperCase();
      e.target.value = inputValue;
    }

    // console.log('handleChange')
    if (input_name_ref.current.value !== "" && input_email_ref.current.value !== "" && input_school_ref.current.value !== "" && input_zip_code_ref.current.value !== "") {
      setFormCompleted(true)
    } else {
      setFormCompleted(false)
    }
  };

  const handleFocus = (event) => {
    if (device.type !== 'desktop') {
        const el = event.target.closest('.sig_BugReport_New_InputContainer');
        el.scrollIntoView({behavior: "smooth"});
    }
  }

  return (
    <Dialog className="sig_Drawer_SettingsModal_Root sig_BugReport_New_Root" open={openDialog} onClose={handleClose}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon">
        {t("sCreateTeams.title")} <GroupsIcon />
      </DialogTitle>
      <DialogContent className="sig_Drawer_SettingsModal_Content sig_BugReport_New_Content">
        <p>{t("sCreateTeams.info").split('.').map((item, key) => {
          return <p key={key}>{item.trim()}</p>;
        })}</p>
        <hr />
        <div data-tour="tourBug_3" className="sig_BugReport_New_Info">
          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title"> {t("sTable.identifier")} </p>
            <TextField     
              className='sig_BugReport_New_TextField'          
              onFocus={(e) => handleFocus(e)}
              onChange={(e) => handleChange(e)}
              margin="dense" 
              id="bugTitle" 
              fullWidth 
              inputRef={input_name_ref} 
              />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title_no_asterisk"> {t("sTeams.table_field_label")} </p>
            <TextField        
              className='sig_BugReport_New_TextField'       
              onFocus={(e) => handleFocus(e)}
              onChange={handleChange}
              margin="dense" 
              id="bugTitle" 
              fullWidth 
              inputRef={input_label_ref} 
              />
          </div>
          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title"> {t("sCreateTeams.contact_mail")} </p>
            <TextField               
              className='sig_BugReport_New_TextField' 
              onFocus={(e) => handleFocus(e)}
              onChange={handleChange}
              margin="dense" 
              id="bugTitle" 
              fullWidth 
              inputRef={input_email_ref} 
              />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title"> {t("sCreateTeams.name_center_association")}</p>
            <TextField    
              className='sig_BugReport_New_TextField'          
              onFocus={(e) => handleFocus(e)}
              onChange={handleChange}
              margin="dense" 
              id="bugTitle" 
              fullWidth 
              inputRef={input_school_ref} 
              />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title"> {t("sCreateTeams.address_center")} </p>
            <TextField 
              className='sig_BugReport_New_TextField' 
              margin="dense" id="bugBody" 
              onFocus={(e) => handleFocus(e)}
              onChange={handleChange}
              fullWidth 
              inputRef={input_zip_code_ref} 
              multiline rows={2} />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title_no_asterisk"> {t("sCreateTeams.more_info")} </p>
            <TextField 
              className='sig_BugReport_New_TextField' 
              margin="dense" id="bugBody" 
              onFocus={(e) => handleFocus(e)}
              onChange={handleChange}
              fullWidth 
              inputRef={input_information_ref} 
              multiline rows={4} />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div>

          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Send" onClick={sendForm} disabled={!formCompleted}>
            {t("strButton.btn_send")}
          </Button>
          
          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Cancel" onClick={handleClose}>
            {t("strButton.btn_cancel")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
